import React from 'react'

const LEGACY_PROVIDERS = [
    'ai.text.translate.sdl.language_cloud_translation_toolkit',
    'ai.text.translate.sdl.enterprise_translation_server',
    'sdlets',
    'sdllanguagecloudtranslation',
]

export const LegacyMark = ({ providerId }) => {
    if (!LEGACY_PROVIDERS.includes(providerId)) {
        return null
    }

    return (
        <span className="try-intento__legacy-product-mark">
            (legacy product)
        </span>
    )
}



// WEBPACK FOOTER //
// /usr/src/app/frontend/src/components/LegacyMark.jsx